import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import RadioButton from '@components/RadioButton';
import Text from '@components/Text';
import TextField from '@components/TextField';
import { useAtomValue } from 'jotai';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import { paymentMethodAtom } from '../../atoms/paymentAtoms';

function CashReceipt() {
    const [value, setValue] = useState<string>('none');
    const method = useAtomValue(paymentMethodAtom);
    const { t } = useTranslation('order');
    if (method === 'prepay') {
        return (
            <Column spacing={8}
                fullWidth
                className={styles.container}>
                <div className={styles.title}>
                    <Text size='lg' fontWeight='bold'>{t('cashReceipt.title')}</Text>
                </div>
                <RadioButton value={value}
                    onChange={setValue}
                    options={[
                        { value: 'none', label: t('cashReceipt.none') },
                        { value: 'private', label: t('cashReceipt.private') },
                        { value: 'business', label: t('cashReceipt.business') },
                    ]}/>
                <TextField placeholder={t('cashReceipt.phonePlaceholder')}/>
                <Checkbox>{t('cashReceipt.saveNumber')}</Checkbox>
            </Column>
        );
    }
    return <Fragment/>;
}

export default CashReceipt;
